import React from 'react';

function QuickView({ product, onClose }) {
  if (!product) return null;

  return (
    <div className={`quickview ${product ? 'active' : ''}`}>
      <div className="quickview-overlay" onClick={onClose}></div>
      <div className="quickview-content">
        <button className="quickview-close" onClick={onClose}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
        <div className="quickview-body">
          <div className="quickview-image">
            <img 
              src={product.image} 
              alt={product.name}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '🍰';
              }}
            />
          </div>
          <div className="quickview-info">
            <span className="quickview-category">{product.tag}</span>
            <h2 className="quickview-title">{product.name}</h2>
            <p className="quickview-desc">{product.description}</p>
            <div className="quickview-price">
              <span className="price-current">¥{product.price}</span>
              {product.originalPrice && (
                <span className="price-original">¥{product.originalPrice}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuickView;
